import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatDividerModule } from '@angular/material/divider'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {NgxMaskDirective} from 'ngx-mask';
import {MedicalInsuranceService} from '../../../core/services/medical-insurance/municipality/medical-insurance.service';

@Component({
  selector: 'medical-insurance-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatOption,
    MatSelect,
    MatDividerModule,
    MatSlideToggle,
    NgxMaskDirective,
  ],
  templateUrl: './medical-insurance-create.component.html',
  styleUrl: './medical-insurance-create.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    EmployeeService,
    HabitsService,
    AddressTypeService,
  ],
  standalone: true,
})
export class MedicalInsuranceCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private locationService: MedicalInsuranceService,
    private snackbar: SnackbarCustomService,
    private viaCepService: ViaCepService,
    private dialogRef: MatDialogRef<MedicalInsuranceCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})

  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      descricao: this.form.get('description')?.value,
      status_id: this.form.get('active')?.value === true ? 1 : 2,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      active: [true],
    })
  }
  createLocation() {
    this.loading = true
    this.locationService.createMunicipality(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
}
